import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "../Styles/UpdateProject.css";
import LayOut from "../../components/LayOut";

const UpdateProject = ({ projectId }) => {
  const [project, setProject] = useState({
    name: "",
    description: "",
    OutputUrl: "",
    photo: null,
  });
  const [newPhoto, setNewPhoto] = useState(null);

  useEffect(() => {
    // Fetch the project details from the database
    const fetchProject = async () => {
      try {
        const response = await fetch(
          `https://portfoliomern-mxue.onrender.com/api/v1/project/${projectId}`
        );
        const data = await response.json();
        if (data.success) {
          setProject(data.project);
        } else {
          console.error("Failed to fetch project");
        }
      } catch (error) {
        console.error("Error fetching project:", error);
      }
    };

    fetchProject();
  }, [projectId]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setProject({ ...project, [name]: value });
  };

  const handlePhotoChange = (e) => {
    setNewPhoto(e.target.files[0]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append("name", project.name);
    formData.append("description", project.description);
    formData.append("OutputUrl", project.OutputUrl);
    if (newPhoto) {
      formData.append("photo", newPhoto);
    }

    try {
      const response = await fetch(
        `/api/v1/project/update-project/${projectId}`,
        {
          method: "PUT",
          body: formData,
        }
      );
      const data = await response.json();
      if (data.success) {
        alert("Project updated successfully");
      } else {
        alert("Failed to update project");
      }
    } catch (error) {
      console.error("Error updating project:", error);
      alert("Error updating project");
    }
  };

  return (
    <LayOut title={"Projects"}>
      <div className="update-project-container">
        <form onSubmit={handleSubmit} className="update-project-form">
          <div className="mb-3">
            <img
              src={
                project.photo?.data
                  ? `data:${project.photo.contentType};base64,${btoa(
                      new Uint8Array(project.photo.data.data).reduce(
                        (data, byte) => data + String.fromCharCode(byte),
                        ""
                      )
                    )}`
                  : "https://via.placeholder.com/300"
              }
              alt="Project"
              className="img-fluid rounded mb-3"
            />
            <input
              type="file"
              accept="image/*"
              className="form-control"
              onChange={handlePhotoChange}
            />
          </div>
          <div className="mb-3">
            <input
              type="text"
              name="name"
              value={project.name}
              placeholder="Project Name"
              className="form-control"
              onChange={handleInputChange}
            />
          </div>
          <div className="mb-3">
            <textarea
              name="description"
              value={project.description}
              placeholder="Project Description"
              className="form-control"
              rows="3"
              onChange={handleInputChange}
            ></textarea>
          </div>
          <div className="mb-3">
            <input
              type="text"
              name="OutputUrl"
              value={project.OutputUrl}
              placeholder="Output URL"
              className="form-control"
              onChange={handleInputChange}
            />
          </div>
          <button type="submit" className="btn btn-primary w-100">
            Update Project
          </button>
        </form>
      </div>
    </LayOut>
  );
};

export default UpdateProject;
